// extracted by mini-css-extract-plugin
export var delivery = "Services-module--delivery--VSSLF";
export var service = "Services-module--service--LSmJq";